import {
  Address,
  Application,
  BusinessInfo,
  OriginalPlanInfo,
  SpouseTrusteeInfo,
  TrusteeInfo,
  User
} from "api/sdk"
import {v4 as uuidv4} from "uuid"

export const getEmptyApplication = (owner: User): Application => ({
  _id: uuidv4(),
  owner: owner._id,
  trustee: null,
  business: null,
  existing: null,
  originalPlan: null,
  spouse: null,
  spouseTrusteeInfo: null,
  desiredTrustName: null,
  notes: "",
  stripe: null,
  signature: null,
  solera: null,
  readyForReview: false,
  review: null
})

export const emptyBusinessInfo: BusinessInfo = {
  name: null,
  phone: null,
  startedAt: null,
  address: null,
  businessForm: null,
  stateOfFormation: null,
  entityIdentificationNumber: null,
  naicsCodeOrDescription: null,
  fiscalYearEnd: null
}

export const emptyTrusteeInfo: TrusteeInfo = {
  givenName: null,
  middleName: null,
  surname: null,
  address: null,
  phone: null,
  socialSecurityNumber: null,
  birthday: null
}

export const emptyAddress: Address = {
  line1: null,
  line2: null,
  city: null,
  state: null,
  country: null,
  postalCode: null
}

export const emptyOriginalPlanInfo: OriginalPlanInfo = {
  originalPlanDate: null,
  originalTrustEin: null
}

export const emptySpouseTrusteeInfo: SpouseTrusteeInfo = {
  fullLegalName: null,
  email: null
}
